import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { buildAedCashoutDraft } from '../cashout-draft-builders';
import { CashoutDraft } from '../cashout-currency.types';
import {
  AED_FUSE_PAYOUT_PURPOSE_OPTIONS,
  setAedFuseBeneficiaryType,
  setupAedCashoutForm,
  updateAedFusePayoutValidators,
} from './aed-form.logic';

@Component({
  selector: 'app-aed-form',
  templateUrl: './aed-form.component.html',
  styleUrl: '../../add-cashout.component.scss',
})
export class AedFormComponent implements OnInit {
  @Input() ctx!: any;
  @Output() draftReady = new EventEmitter<CashoutDraft>();

  readonly fusePayoutPurposeOptions = AED_FUSE_PAYOUT_PURPOSE_OPTIONS;

  ngOnInit(): void {
    setupAedCashoutForm(this.ctx);
  }

  setFuseBeneficiaryType(type: 'individual' | 'corporate'): void {
    setAedFuseBeneficiaryType(this.ctx, type);
  }

  onFuseRailChange(): void {
    updateAedFusePayoutValidators(this.ctx);
  }

  saveTransaction(): void {
    const draft = buildAedCashoutDraft(this.ctx);
    if (draft) {
      this.draftReady.emit(draft);
    }
  }
}
